import styled from "styled-components";
import { COLORS, STYLE_CONSTS } from "~/src/styles/config.style";

export const Tab = styled.span`
  margin-right: ${STYLE_CONSTS.UNIT_3};
  display: ${({ shouldHide }) => (shouldHide ? "none" : "")};
  color: ${({ isDisabled }) => (isDisabled ? COLORS.CLOUDY_BLUE : "inherit")};
  cursor: pointer;
`;
